import './TopBarBell.scss'

export const TopBarBell = ({value = 0}) => {
    return (
        <div className={'main'}>
            <div className={'notification'}>
                <svg viewBox="0 0 15 17">
                    <path
                        className={value > 0 ? 'notification--bell' : ''}
                        d="M14 12v1H0v-1l0.73-0.58c0.77-0.77 0.81-3.55 1.19-4.42 0.77-3.77 4.08-5 4.08-5 0-0.55 0.45-1 1-1s1 0.45 1 1c0 0 3.39 1.23 4.16 5 0.38 1.88 0.42 3.66 1.19 4.42l0.66 0.58z"></path>
                    <path
                        className={value > 0 ? 'notification--bellClapper' : ''}
                        d="M7 15.7c1.11 0 2-0.89 2-2H5c0 1.11 0.89 2 2 2z"></path>
                </svg>
            </div>
        </div>
    )
}
